class TrialLicence {
    constructor(showLicenceTrialModal, showLicenceTrialActivatedModal, showLicenceTrialExpirationModal, showLicenceTrialBookShowcaseModal) {
        let searchParams = new URLSearchParams(window.location.search);
        this.organizationID = searchParams.get('organizationID');

        this.showModal(showLicenceTrialModal, showLicenceTrialActivatedModal, showLicenceTrialExpirationModal, showLicenceTrialBookShowcaseModal);
    }
    showModal(showLicenceTrialModal, showLicenceTrialActivatedModal, showLicenceTrialExpirationModal, showLicenceTrialBookShowcaseModal){
        if(showLicenceTrialModal){
            new bootstrap.Modal(document.getElementById('licence_trial_modal'), {}).show();
            this.closeLicenceTrial();
        }
        if(showLicenceTrialActivatedModal){
            new bootstrap.Modal(document.getElementById('licence_trial_modal_activated'), {}).show();
        }
        if(showLicenceTrialExpirationModal){
            new bootstrap.Modal(document.getElementById('licence_trial_modal_expiration'), {}).show();
        }
        if(showLicenceTrialBookShowcaseModal){
            new bootstrap.Modal(document.getElementById('licence_trial_modal_book_showcase'), {}).show();
            new DismissModal('licence_trial_modal_book_showcase').disable(true);
            this.remindMeLaterLicenceTrialBookShowcase();
        }
    }
    closeLicenceTrial(){
        let thisClass = this;
        const closeBtns = [].slice.call(document.querySelectorAll("#licence_trial_modal .close-licence-trial"));
        closeBtns.forEach((closeBtn) => {
            closeBtn.addEventListener("click", function () {
                new bootstrap.Modal(document.getElementById('licence_trial_modal'), {}).hide();
                let licenceTrialEventID = closeBtn.getAttribute("data-action-id");
                $.ajax({
                    url: '?do=closeLicenceTrial',
                    type: 'GET',
                    dataType: '',
                    data: {
                        organizationID: thisClass.organizationID,
                        licenceTrialEventID: licenceTrialEventID
                    }
                }).done(function(data) {

                });
            });
        });
    }
    remindMeLaterLicenceTrialBookShowcase(){
        let thisClass = this;
        const remindMeLaterBtn = document.querySelector("#licence_trial_modal_book_showcase .remind-me-later-book-showcase")
        remindMeLaterBtn.addEventListener("click", function () {
            fetch('?do=remindMeLaterBookShowcase&organizationID='+thisClass.organizationID)
                .then(response => {

                });
        });
    }
}
window.TrialLicence = TrialLicence;